const FOCUSABLE_QUERY_STRING: string = `
  a[href],
  button,
  textarea,
  input[type="text"],
  input[type="radio"],
  input[type="checkbox"],
  select,
  [tabindex]:not([tabindex="-1"]
`;

const elementIsVisible: (el: HTMLElement) => boolean = el => {
  if (
    window.getComputedStyle(el).display === 'none' ||
    window.getComputedStyle(el).opacity === '0' ||
    window.getComputedStyle(el).visibility === 'hidden'
  ) { return false; }
  if (el.parentElement === null) { return true; }

  return elementIsVisible(el.parentElement);
};

type GetFocusableElements = (node: HTMLElement | null) => undefined |
  {
    firstElement: HTMLElement;
    lastElement: HTMLElement;
  }
;

export const getFocusableElements: GetFocusableElements = (node: HTMLElement | null) => {
  if (node) {
    const focusableElementNodes: NodeListOf<HTMLElement> = node.querySelectorAll(FOCUSABLE_QUERY_STRING);

    const focusableElements: HTMLElement[] = Array.from(focusableElementNodes);
    const visibleElements = focusableElements.filter(elementIsVisible);

    return {
      firstElement: visibleElements[0],
      lastElement: visibleElements[visibleElements.length - 1]
    };
  }
};
